export default "__VITE_ASSET__BMP2apQ1__"